<template>
    <svg :class="visibility" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1920.79 110.27">
        <g :stroke="strokeColor"
           :stroke-width="width">
            <path id="background"
                  d="M-.79,491.06H776.74a133.69,133.69,0,0,1,106.1,52.34h0l16.67,18.66a78.66,78.66,0,0,0,58.67,26.26h0a78.69,78.69,0,0,0,56.47-23.89l20.42-21h0a152.76,152.76,0,0,1,115.13-52.34H1920"
                  transform="translate(0.79 -484.56)"/>
        </g>
    </svg>
</template>

<script>

    export default {
        name: "JulioBottomNavigationLine",
        props: {
            width: {
                type: [Number, String],
                default: "13px"
            },
            height: {
                type: [Number, String],
                default: 18
            },
            iconColor: {
                type: String,
                default: '#263238'
            },
            show: {
                type: Boolean,
                default: false
            },
            animate: {
                type: Boolean,
                default: true
            },
            scrollThreshold: {
                type: Number,
                default: 0,
            }
        },
        data() {
            return {
                strokeWidths: this.width
            }
        },
        computed: {
            visibility: function () {
                if (this.animate)
                    return {
                        iconReveal: this.show,
                        iconHide: !this.show
                    }
                else
                    return {iconNormal: true}
            },
            strokeColor: function () {
                if (this.animate) return ""
                else return this.iconColor
            },
        },
        methods: {}
    }
</script>

<style lang="scss" src="../../styles/icons/juliobottomnavigationline.scss" scoped/>